import { create } from "zustand"
import { persist } from "zustand/middleware"
import type { BooruPost } from "./booru-api"

interface PipState {
  // Current PIP content
  pipPost: BooruPost | null
  isPipActive: boolean
  isPipMinimized: boolean

  // PIP settings
  pipPosition: "bottom-right" | "bottom-left" | "top-right" | "top-left"
  pipSize: "small" | "medium" | "large" | "xlarge"
  pipMuted: boolean
  pipVolume: number
  pipPlaybackSpeed: number

  // Actions
  openPip: (post: BooruPost) => void
  closePip: () => void
  togglePipMinimized: () => void
  setPipPosition: (position: "bottom-right" | "bottom-left" | "top-right" | "top-left") => void
  setPipSize: (size: "small" | "medium" | "large" | "xlarge") => void
  setPipMuted: (muted: boolean) => void
  setPipVolume: (volume: number) => void
  setPipPlaybackSpeed: (speed: number) => void
}

export const usePipStore = create<PipState>()(
  persist(
    (set) => ({
      pipPost: null,
      isPipActive: false,
      isPipMinimized: false,
      pipPosition: "bottom-right",
      pipSize: "medium",
      pipMuted: false,
      pipVolume: 0.5,
      pipPlaybackSpeed: 1,

      openPip: (post) => set({ pipPost: post, isPipActive: true, isPipMinimized: false }),
      closePip: () => set({ pipPost: null, isPipActive: false, isPipMinimized: false }),
      togglePipMinimized: () => set((state) => ({ isPipMinimized: !state.isPipMinimized })),
      setPipPosition: (position) => set({ pipPosition: position }),
      setPipSize: (size) => set({ pipSize: size }),
      setPipMuted: (muted) => set({ pipMuted: muted }),
      setPipVolume: (volume) => set({ pipVolume: volume }),
      setPipPlaybackSpeed: (speed) => set({ pipPlaybackSpeed: speed }),
    }),
    {
      name: "pip-storage",
      partialize: (state) => ({
        pipPosition: state.pipPosition,
        pipSize: state.pipSize,
        pipMuted: state.pipMuted,
        pipVolume: state.pipVolume,
        pipPlaybackSpeed: state.pipPlaybackSpeed,
      }),
    },
  ),
)
